
import { Volver } from '../assets/icons'
import useListadoDeArchivos from '../hooks/useListadoDeArchivos'
import { useEmpleadoStore } from '../stores/useEmpleadoStore'
import ItemCarpeta from './ItemCarpeta'
import Card from 'react-bootstrap/Card';
import url from '../api/url';
import NavbarMio from './NavbarMio';

function ListadoDeArchivos() {

    const { errorCarpetas, EnlaceTitulo, cargandoArchivos, tipoArchivo, cargandoArchivos2 } = useListadoDeArchivos()
    const { carpeta, actualizarCarpeta, jsonArchivos, listaArchivos, listaArchivosOtros } = useEmpleadoStore()
    const { SERVIDOR } = url()

    return (

        <div className="row">
            <div className="d-flex justify-content-center mt-4 mb-5">
                <div className="col-md-8 col-12">
                    <div className="card">


                        <div className="card-header">
                            <NavbarMio ruta='archivos'/>
                        </div>


                        <div className='px-5 py-3 card-body'>
                            {errorCarpetas && (
                                <div className='alert alert-warning'>
                                    <div>Hay problemas al mostrar las carpetas de los empleados.</div>
                                </div>
                            )}
                            { carpeta ? carpeta : '' }

                            {carpeta && (
                                <div className='d-flex justify-content-start'>
                                    <button className='btn btn-outline-secondary' onClick={() => actualizarCarpeta(null)}>
                                        <Volver/>
                                    </button>
                                </div>
                            )}

                            { !carpeta &&(
                                <div className='d-flex flex-wrap gap-3'>
                                    { jsonArchivos.map((e, i) => <ItemCarpeta key={i} texto={e.nombre_carpeta}/>) }
                                </div>
                            )}

                            { carpeta ? <div className='alert alert-info my-3'>
                                Listado de escolaridades, cédulas y títulos de este empleado.
                            </div> : ''}

                            { cargandoArchivos && <div className="d-flex justify-content-center">
                                    <div className="spinner-border" role="status">
                                        <span className="visually-hidden">Loading...</span>
                                    </div>
                                </div>}

                            {/* eslint-disable-next-line */}
                            { (carpeta && listaArchivos.length == 0) ? 'Este empleado no ha registrado escolaridades.' : '' }
                            { carpeta &&(
                                <div className='d-flex flex-wrap justify-content-center gap-3'>
                                    { listaArchivos.map( ( e, i ) => (
                                        <Card style={{ width: '20rem' }} key={i}>
                                            <Card.Body>
                                                <Card.Title>{ e.escolaridad }</Card.Title>
                                                {/* eslint-disable-next-line */}
                                                { e.es_titulado == 0
                                                    ? <Card.Subtitle className="mb-2 text-muted">No titulado</Card.Subtitle>
                                                    : <Card.Subtitle className="mb-2 text-muted">&nbsp;</Card.Subtitle> }
                                                <Card.Text>
                                                    {e.carrera}
                                                </Card.Text>
                                                <EnlaceTitulo es_titulado={e.es_titulado} archivo={e.archivo_cedula} texto='Cédula' carpeta={carpeta} />&nbsp;|&nbsp;
                                                <EnlaceTitulo es_titulado={e.es_titulado} archivo={e.archivo_titulo} texto='Título' carpeta={carpeta} />
                                            </Card.Body>
                                        </Card>
                                    ))}
                                </div>
                            )}

                            { carpeta && <div className='alert alert-info mt-5'>
                                Listado de documentos de este empleado.
                            </div>}

                            { cargandoArchivos2 && <div className="d-flex justify-content-center">
                                    <div className="spinner-border" role="status">
                                        <span className="visually-hidden">Loading...</span>
                                    </div>
                                </div>}

                            <ul>
                                { listaArchivosOtros.map( (e, i) => (
                                    <li key={i} className='text-start mb-3'>
                                        <a href={ `${SERVIDOR}/archivos/${carpeta}/${e.nombre_archivo}` } target='_blank' rel='noreferrer'>
                                            { tipoArchivo( e.tipo ) }
                                        </a>
                                    </li>
                                ))}
                            </ul>

                        </div>

                    </div>
                </div>
            </div>
        </div>
    )
}

export default ListadoDeArchivos
